// March 2026 School Calendar Events — English & Spanish
// Categories: holiday, academic, community, spirit, enrichment

const events = [
  // ==================== WEEK 1: March 1–7 ====================
  {
    id: 'march-madness',
    title: 'Kick Off March Madness',
    titleES: 'Comienza la locura de marzo',
    description: 'Start of March Madness spirit activities for the whole school.',
    descriptionES: 'Inicio de las actividades de la locura de marzo para toda la escuela.',
    date: new Date(2026, 2, 2),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'summer-rising',
    title: 'Summer Rising Kick Off',
    titleES: 'Inicio del Summer Rising',
    description: 'Information session about the Summer Rising program.',
    descriptionES: 'Sesión informativa sobre el programa Summer Rising.',
    date: new Date(2026, 2, 3),
    category: 'academic',
    allDay: false,
    startTime: '2:30 PM',
    endTime: '3:30 PM',
  },
  {
    id: 'save-college-mar4',
    title: 'Save for College',
    titleES: 'Ahorra para la universidad',
    description: 'College savings information and enrollment session.',
    descriptionES: 'Sesión informativa y de inscripción para ahorro universitario.',
    date: new Date(2026, 2, 4),
    category: 'academic',
    allDay: false,
    startTime: '8:30 AM',
    endTime: '9:30 AM',
  },
  {
    id: 'choc-strawberries',
    title: 'Chocolate Strawberries & Roses (Parent Survey)',
    titleES: 'Fresas con chocolate y rosas (Encuesta para padres)',
    description: 'Enjoy chocolate strawberries and roses while completing the parent survey.',
    descriptionES: 'Disfruta de fresas con chocolate y rosas mientras completas la encuesta para padres.',
    date: new Date(2026, 2, 4),
    category: 'community',
    allDay: false,
    startTime: '2:30 PM',
    endTime: '4:00 PM',
  },
  {
    id: 'ptc-conference',
    title: 'PTC Conference — 11:20 AM Dismissal',
    titleES: 'Conferencia PTC — Salida a las 11:20 AM',
    description: 'Parent-Teacher Conference day. Early dismissal at 11:20 AM.',
    descriptionES: 'Día de conferencia de padres y maestros. Salida temprana a las 11:20 AM.',
    date: new Date(2026, 2, 5),
    category: 'academic',
    allDay: false,
    startTime: '11:20 AM',
  },
  {
    id: 'jersey-mar6',
    title: 'Wear Your Jersey',
    titleES: 'Usa tu camiseta',
    description: 'Spirit day — wear your favorite team jersey to school!',
    descriptionES: 'Día de espíritu — usa tu camiseta favorita de equipo.',
    date: new Date(2026, 2, 6),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'swim-mar6',
    title: 'Swim for Life (Rm 2-219)',
    titleES: 'Nadar por la vida (Salón 2-219)',
    description: 'Swim for Life program session in Room 2-219.',
    descriptionES: 'Sesión del programa Nadar por la vida en el salón 2-219.',
    date: new Date(2026, 2, 6),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'sat-academy-mar7',
    title: 'Saturday Academy',
    titleES: 'Academia del sábado',
    description: 'Weekend enrichment and academic support program.',
    descriptionES: 'Programa de enriquecimiento y apoyo académico de fin de semana.',
    date: new Date(2026, 2, 7),
    category: 'enrichment',
    allDay: true,
  },

  // ==================== WEEK 2: March 8–14 ====================
  {
    id: 'slt-meeting',
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    description: 'School Leadership Team meeting.',
    descriptionES: 'Reunión del Equipo de Liderazgo Escolar.',
    date: new Date(2026, 2, 10),
    category: 'academic',
    allDay: false,
    startTime: '4:00 PM',
  },
  {
    id: 'parent-survey-week',
    title: 'Parent Survey Week',
    titleES: 'Semana de encuesta para padres',
    description: 'Complete the parent survey — sessions available 8:30 AM to 9:30 AM.',
    descriptionES: 'Complete la encuesta para padres — sesiones de 8:30 a.m. a 9:30 a.m.',
    date: new Date(2026, 2, 10),
    endDate: new Date(2026, 2, 12),
    category: 'community',
    allDay: false,
    startTime: '8:30 AM',
    endTime: '9:30 AM',
  },
  {
    id: 'parent-circle',
    title: 'Parent Circle',
    titleES: 'Círculo de padres',
    description: 'Parent Circle discussion and community-building session.',
    descriptionES: 'Sesión de discusión y construcción de comunidad del Círculo de padres.',
    date: new Date(2026, 2, 12),
    category: 'community',
    allDay: false,
    startTime: '8:30 AM',
    endTime: '9:30 AM',
  },
  {
    id: 'swim-mar12',
    title: 'Swim for Life (Rm 2-317)',
    titleES: 'Nadar por la vida (Salón 2-317)',
    description: 'Swim for Life program session in Room 2-317.',
    descriptionES: 'Sesión del programa Nadar por la vida en el salón 2-317.',
    date: new Date(2026, 2, 12),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'jersey-mar13',
    title: 'Wear Your Jersey',
    titleES: 'Usa tu camiseta',
    description: 'Spirit day — wear your favorite team jersey to school!',
    descriptionES: 'Día de espíritu — usa tu camiseta favorita de equipo.',
    date: new Date(2026, 2, 13),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'movie-night',
    title: 'Movie Night — Air Bud',
    titleES: 'Noche de cine — Air Bud',
    description: 'Family movie night featuring Air Bud.',
    descriptionES: 'Noche de cine familiar con la película Air Bud.',
    date: new Date(2026, 2, 13),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'swim-mar13',
    title: 'Swim for Life (Rm 2-219)',
    titleES: 'Nadar por la vida (Salón 2-219)',
    description: 'Swim for Life program session in Room 2-219.',
    descriptionES: 'Sesión del programa Nadar por la vida en el salón 2-219.',
    date: new Date(2026, 2, 13),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'sat-academy-mar14',
    title: 'Saturday Academy',
    titleES: 'Academia del sábado',
    description: 'Weekend enrichment and academic support program.',
    descriptionES: 'Programa de enriquecimiento y apoyo académico de fin de semana.',
    date: new Date(2026, 2, 14),
    category: 'enrichment',
    allDay: true,
  },

  // ==================== WEEK 3: March 15–21 ====================
  {
    id: 'lucky-glow',
    title: 'Lucky Number — Get Your Glow Stick',
    titleES: 'Número de la suerte — Consigue tu barra luminosa',
    description: 'Lucky Number spirit event — pick up your glow stick!',
    descriptionES: 'Evento de espíritu Número de la suerte — recoge tu barra luminosa.',
    date: new Date(2026, 2, 16),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'wear-green',
    title: 'Wear Green & Lucky Number Ducks',
    titleES: 'Viste de verde y consigue tu número de la suerte Patos',
    description: 'Wear green for St. Patrick\'s Day and get your Lucky Number Ducks!',
    descriptionES: 'Viste de verde por el Día de San Patricio y consigue tus Patos de la suerte.',
    date: new Date(2026, 2, 17),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'lucky-sports',
    title: 'Lucky Number Sports',
    titleES: 'Números de la suerte en los deportes',
    description: 'Lucky Number themed sports activities.',
    descriptionES: 'Actividades deportivas con el tema Números de la suerte.',
    date: new Date(2026, 2, 18),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'pta-theme',
    title: 'Theme PTA Meeting',
    titleES: 'Reunión temática de la PTA',
    description: 'Themed Parent-Teacher Association meeting.',
    descriptionES: 'Reunión temática de la Asociación de Padres y Maestros.',
    date: new Date(2026, 2, 18),
    category: 'community',
    allDay: false,
    startTime: '5:00 PM',
  },
  {
    id: 'fitness-night',
    title: 'Fitness Night',
    titleES: 'Noche de ejercicios',
    description: 'Evening fitness activities for families.',
    descriptionES: 'Actividades de ejercicios nocturnos para familias.',
    date: new Date(2026, 2, 18),
    category: 'enrichment',
    allDay: false,
    startTime: '5:30 PM',
  },
  {
    id: 'aladdin-trip',
    title: 'Grade 4 Aladdin Trip',
    titleES: 'Viaje de Aladino de 4.° grado',
    description: 'Fourth grade field trip to see Aladdin.',
    descriptionES: 'Excursión de cuarto grado para ver Aladino.',
    date: new Date(2026, 2, 18),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'pajama-day',
    title: 'Pajama Day & Ice Cream',
    titleES: 'Día de pijama y helado',
    description: 'Wear your pajamas to school and enjoy ice cream!',
    descriptionES: 'Ven en pijama a la escuela y disfruta de helado.',
    date: new Date(2026, 2, 19),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'save-college-mar19',
    title: 'Save for College',
    titleES: 'Ahorrar para la universidad',
    description: 'College savings information and enrollment session.',
    descriptionES: 'Sesión informativa y de inscripción para ahorro universitario.',
    date: new Date(2026, 2, 19),
    category: 'academic',
    allDay: false,
    startTime: '2:30 PM',
    endTime: '3:30 PM',
  },
  {
    id: 'swim-mar19',
    title: 'Swim for Life (Rm 2-317)',
    titleES: 'Nadar por la vida (Salón 2-317)',
    description: 'Swim for Life program session in Room 2-317.',
    descriptionES: 'Sesión del programa Nadar por la vida en el salón 2-317.',
    date: new Date(2026, 2, 19),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'family-attendance',
    title: 'Family Attendance Celebration',
    titleES: 'Celebración de la asistencia familiar',
    description: 'Celebrating families with outstanding attendance.',
    descriptionES: 'Celebrando a las familias con asistencia sobresaliente.',
    date: new Date(2026, 2, 19),
    category: 'community',
    allDay: true,
  },
  {
    id: 'no-school-mar20',
    title: 'No School',
    titleES: 'No hay escuela',
    description: 'School closed — no classes today.',
    descriptionES: 'Escuela cerrada — no hay clases hoy.',
    date: new Date(2026, 2, 20),
    category: 'holiday',
    allDay: true,
  },
  {
    id: 'sat-academy-mar21',
    title: 'Saturday Academy',
    titleES: 'Academia del sábado',
    description: 'Weekend enrichment and academic support program.',
    descriptionES: 'Programa de enriquecimiento y apoyo académico de fin de semana.',
    date: new Date(2026, 2, 21),
    category: 'enrichment',
    allDay: true,
  },

  // ==================== WEEK 4: March 22–28 (College & Career Week) ====================
  {
    id: 'college-career-week',
    title: 'College & Career Week',
    titleES: 'Semana de la Universidad y la Carrera',
    description: 'A full week of college and career readiness activities and celebrations.',
    descriptionES: 'Una semana completa de actividades y celebraciones de preparación universitaria y profesional.',
    date: new Date(2026, 2, 22),
    endDate: new Date(2026, 2, 27),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'girl-power',
    title: 'Girl Power Day — Barbie & Ken',
    titleES: 'Día de las Chicas Poderosas — Barbie y Ken',
    description: 'Celebrate Girl Power Day by dressing as Barbie & Ken!',
    descriptionES: 'Celebra el Día de las Chicas Poderosas vistiéndote como Barbie y Ken.',
    date: new Date(2026, 2, 23),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'shine-bright',
    title: 'Shine Bright Day — Sunglasses Day',
    titleES: 'Día de brillar intensamente — Día de las gafas de sol',
    description: 'Wear your coolest sunglasses and shine bright!',
    descriptionES: 'Usa tus mejores gafas de sol y brilla intensamente.',
    date: new Date(2026, 2, 24),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'dream-big',
    title: 'Dream Big Day & Mini Easter Basket',
    titleES: 'Día de los sueños en grande y minicanasta de Pascua',
    description: 'Dress as what you want to be when you grow up. Plus, mini Easter basket fun!',
    descriptionES: 'Vístete como quieres ser cuando seas grande. Además, minicanastas de Pascua.',
    date: new Date(2026, 2, 25),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'school-survey',
    title: 'School Survey Event',
    titleES: 'Evento de encuesta escolar',
    description: 'Complete the school survey to share your feedback.',
    descriptionES: 'Complete la encuesta escolar para compartir sus comentarios.',
    date: new Date(2026, 2, 25),
    category: 'community',
    allDay: true,
  },
  {
    id: 'college-swag',
    title: 'College Swag Day',
    titleES: 'Día del Swag Universitario',
    description: 'Show your college spirit by wearing college gear!',
    descriptionES: 'Muestra tu espíritu universitario usando ropa de universidades.',
    date: new Date(2026, 2, 26),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'save-college-mar26',
    title: 'Save for College',
    titleES: 'Ahorrar para la universidad',
    description: 'College savings information and enrollment session.',
    descriptionES: 'Sesión informativa y de inscripción para ahorro universitario.',
    date: new Date(2026, 2, 26),
    category: 'academic',
    allDay: false,
    startTime: '2:30 PM',
    endTime: '3:30 PM',
  },
  {
    id: 'swim-mar26',
    title: 'Swim for Life (Rm 2-317)',
    titleES: 'Nadar por la vida (Salón 2-317)',
    description: 'Swim for Life program session in Room 2-317.',
    descriptionES: 'Sesión del programa Nadar por la vida en el salón 2-317.',
    date: new Date(2026, 2, 26),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'career-fair',
    title: 'College/Career FAIR',
    titleES: 'FERIA Universitaria/Profesional',
    description: 'Explore college and career options at the annual fair.',
    descriptionES: 'Explora opciones universitarias y profesionales en la feria anual.',
    date: new Date(2026, 2, 27),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'swim-mar27',
    title: 'Swim for Life (Rm 2-219)',
    titleES: 'Nadar por la vida (Salón 2-219)',
    description: 'Swim for Life program session in Room 2-219.',
    descriptionES: 'Sesión del programa Nadar por la vida en el salón 2-219.',
    date: new Date(2026, 2, 27),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'prek-celebrations',
    title: 'Pre-K Bubble Party & Sing Along',
    titleES: 'Fiesta de burbujas y cantando juntos Pre-K',
    description: 'Pre-K students enjoy a bubble party and sing along celebration.',
    descriptionES: 'Los estudiantes de Pre-K disfrutan de una fiesta de burbujas y cantan juntos.',
    date: new Date(2026, 2, 27),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'spirit-mar27',
    title: 'Dress for Success & Wear Your Jersey',
    titleES: 'Vístete para el éxito y usa tu camiseta',
    description: 'Spirit day — dress for success or wear your favorite jersey. Lucky Number Clip Board available.',
    descriptionES: 'Día de espíritu — vístete para el éxito o usa tu camiseta favorita. Tablero con el número de la suerte disponible.',
    date: new Date(2026, 2, 27),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'sat-academy-mar28',
    title: 'Saturday Academy',
    titleES: 'Academia del sábado',
    description: 'Weekend enrichment and academic support program.',
    descriptionES: 'Programa de enriquecimiento y apoyo académico de fin de semana.',
    date: new Date(2026, 2, 28),
    category: 'enrichment',
    allDay: true,
  },

  // ==================== WEEK 5: March 29–31 + April ====================
  {
    id: 'stuffed-animal',
    title: 'Stuffed Animal Day',
    titleES: 'Día del animal de peluche',
    description: 'Bring your favorite stuffed animal to school!',
    descriptionES: 'Trae tu animal de peluche favorito a la escuela.',
    date: new Date(2026, 2, 31),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'no-elt',
    title: 'No ELT Programs',
    titleES: 'No hay programas ELT',
    description: 'Extended Learning Time programs are not in session today.',
    descriptionES: 'Los programas de Tiempo de Aprendizaje Extendido no están en sesión hoy.',
    date: new Date(2026, 3, 1),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'family-game-day',
    title: 'PK-2 Family Game Day',
    titleES: 'Día de juegos familiares PK-2',
    description: 'Family game day for Pre-K through 2nd grade students and families.',
    descriptionES: 'Día de juegos familiares para estudiantes y familias de Pre-K a 2.° grado.',
    date: new Date(2026, 3, 1),
    category: 'community',
    allDay: true,
  },
  {
    id: 'pep-rally',
    title: '3-5 Pep Rally',
    titleES: '3-5 Reunión de motivación',
    description: 'Pep rally for grades 3 through 5.',
    descriptionES: 'Reunión de motivación para los grados 3 a 5.',
    date: new Date(2026, 3, 1),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'spring-recess',
    title: 'Spring Recess',
    titleES: 'Receso de primavera',
    description: 'School closed for Spring Recess. April 2nd through April 10th.',
    descriptionES: 'Escuela cerrada por receso de primavera. Del 2 de abril al 10 de abril.',
    date: new Date(2026, 3, 2),
    endDate: new Date(2026, 3, 10),
    category: 'holiday',
    allDay: true,
  },
  {
    id: 'attendance-raffle',
    title: 'Attendance Raffle — Scooter Prize',
    titleES: 'Rifa de asistencia — Premio Scooter',
    description: 'Scooter raffle for all students with 95%+ attendance from 3/1 through 6/26.',
    descriptionES: 'Rifa de scooter para todos los estudiantes con más del 95% de asistencia del 1 de marzo al 26 de junio.',
    date: new Date(2026, 2, 28),
    category: 'community',
    allDay: true,
  },

  // ==================== MAY 2026 ====================

  // May 1 — Friday
  {
    id: 'may-attendance-scooter-raffle',
    title: 'April Attendance Celebration & Scooter Raffle Day',
    titleES: 'Celebración de Asistencia de Abril y Día de Rifa de Scooter',
    description: 'Celebrating April attendance and the scooter raffle prize draw.',
    descriptionES: 'Celebración de la asistencia de abril y sorteo del premio scooter.',
    date: new Date(2026, 4, 1),
    category: 'community',
    allDay: true,
  },
  {
    id: 'may-studio-9',
    title: 'Studio in a School #9',
    titleES: 'Studio en la Escuela #9',
    description: 'Studio in a School session #9.',
    descriptionES: 'Sesión #9 del programa Studio en la Escuela.',
    date: new Date(2026, 4, 1),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'may-prek-sing-along',
    title: 'Pre-K Sing-Along',
    titleES: 'Cantar Juntos Pre-K',
    description: 'Pre-K Sing-Along celebration.',
    descriptionES: 'Celebración de canto para Pre-K.',
    date: new Date(2026, 4, 1),
    category: 'enrichment',
    allDay: true,
  },

  // May 2 — Saturday
  {
    id: 'may-sat-academy-may2',
    title: 'Saturday Academy',
    titleES: 'Academia del Sábado',
    description: 'Weekend enrichment and academic support program.',
    descriptionES: 'Programa de enriquecimiento y apoyo académico de fin de semana.',
    date: new Date(2026, 4, 2),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'may-d10-science-fair',
    title: 'D10 Science Fair',
    titleES: 'Feria de Ciencias D10',
    description: 'District 10 Science Fair.',
    descriptionES: 'Feria de Ciencias del Distrito 10.',
    date: new Date(2026, 4, 2),
    category: 'academic',
    allDay: true,
  },

  // May 4 — Monday
  {
    id: 'may-wits-greens-setup',
    title: 'WITS Greens 3 Setup',
    titleES: 'Configuración WITS Greens 3',
    description: 'Setup for WITS Greens 3 program.',
    descriptionES: 'Preparación del programa WITS Greens 3.',
    date: new Date(2026, 4, 4),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'may-teacher-appreciation-week',
    title: 'Teacher Appreciation Week',
    titleES: 'Semana de Apreciación a los Maestros',
    description: 'A week to celebrate and honor our dedicated teachers.',
    descriptionES: 'Una semana para celebrar y honrar a nuestros dedicados maestros.',
    date: new Date(2026, 4, 4),
    endDate: new Date(2026, 4, 8),
    category: 'community',
    allDay: true,
  },

  // May 5 — Tuesday
  {
    id: 'may-wits-green-lab-may5',
    title: 'WITS Green Lab K-2, 2-309 Swim',
    titleES: 'WITS Green Lab K-2, Natación 2-309',
    description: 'WITS Green Lab session for K-2 with swimming in Room 2-309.',
    descriptionES: 'Sesión de WITS Green Lab para K-2 con natación en el salón 2-309.',
    date: new Date(2026, 4, 5),
    category: 'enrichment',
    allDay: true,
  },

  // May 6 — Wednesday
  {
    id: 'may-wits-green-lab-may6',
    title: 'WITS Green Lab K-2, 2-218 Swim',
    titleES: 'WITS Green Lab K-2, Natación 2-218',
    description: 'WITS Green Lab session for K-2 with swimming in Room 2-218.',
    descriptionES: 'Sesión de WITS Green Lab para K-2 con natación en el salón 2-218.',
    date: new Date(2026, 4, 6),
    category: 'enrichment',
    allDay: true,
  },

  // May 7 — Thursday
  {
    id: 'may-yankee-bead-day',
    title: 'Yankee Bead Day',
    titleES: 'Día de las Cuentas Yankee',
    description: 'Yankee Bead Day celebration.',
    descriptionES: 'Celebración del Día de las Cuentas Yankee.',
    date: new Date(2026, 4, 7),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'may-attendance-baseball-wits',
    title: 'Attendance & Baseball Club / WITS Green Lab K-2',
    titleES: 'Asistencia y Club de Béisbol / WITS Green Lab K-2',
    description: 'Attendance celebration with Baseball Club and WITS Green Lab K-2 session.',
    descriptionES: 'Celebración de asistencia con Club de Béisbol y sesión de WITS Green Lab K-2.',
    date: new Date(2026, 4, 7),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'may-bronx-zoo-trip',
    title: 'Grade 2 Field Trip to Bronx Zoo',
    titleES: 'Excursión de 2.° Grado al Zoológico del Bronx',
    description: 'Second grade field trip to the Bronx Zoo.',
    descriptionES: 'Excursión de segundo grado al Zoológico del Bronx.',
    date: new Date(2026, 4, 7),
    category: 'enrichment',
    allDay: true,
  },

  // May 8 — Friday
  {
    id: 'may-math-cake-day',
    title: 'Math Cake Day',
    titleES: 'Día del Pastel de Matemáticas',
    description: 'Math Cake Day celebration.',
    descriptionES: 'Celebración del Día del Pastel de Matemáticas.',
    date: new Date(2026, 4, 8),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'may-wits-green-lab-last',
    title: 'WITS Green Lab K-2, Studio in a School #10 — Last Session',
    titleES: 'WITS Green Lab K-2, Studio en la Escuela #10 — Última Sesión',
    description: 'Final WITS Green Lab K-2 session and Studio in a School #10.',
    descriptionES: 'Última sesión de WITS Green Lab K-2 y Studio en la Escuela #10.',
    date: new Date(2026, 4, 8),
    category: 'enrichment',
    allDay: true,
  },

  // May 9 — Saturday
  {
    id: 'may-sat-academy-may9',
    title: 'Saturday Academy',
    titleES: 'Academia del Sábado',
    description: 'Weekend enrichment and academic support program.',
    descriptionES: 'Programa de enriquecimiento y apoyo académico de fin de semana.',
    date: new Date(2026, 4, 9),
    category: 'enrichment',
    allDay: true,
  },

  // May 12 — Tuesday
  {
    id: 'may-intrepid-trip',
    title: 'Intrepid Field Trip — Grade 1, 2-209 Swim',
    titleES: 'Excursión al Intrepid — Grado 1, Natación 2-209',
    description: 'Grade 1 field trip to the Intrepid museum and swimming in Room 2-209.',
    descriptionES: 'Excursión de 1.er grado al museo Intrepid y natación en el salón 2-209.',
    date: new Date(2026, 4, 12),
    category: 'enrichment',
    allDay: false,
    startTime: '4:00 PM',
  },
  {
    id: 'may-slt-meeting',
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    description: 'School Leadership Team meeting at 4:00 PM.',
    descriptionES: 'Reunión del Equipo de Liderazgo Escolar a las 4:00 PM.',
    date: new Date(2026, 4, 12),
    category: 'academic',
    allDay: false,
    startTime: '4:00 PM',
  },

  // May 13 — Wednesday
  {
    id: 'may-nyseslat-day1',
    title: 'K-4 NYSESLAT Day 1 — 2-218 Swim',
    titleES: 'NYSESLAT K-4 Día 1 — Natación 2-218',
    description: 'NYSESLAT testing Day 1 for grades K-4 with swimming in Room 2-218.',
    descriptionES: 'Examen NYSESLAT Día 1 para los grados K-4 con natación en el salón 2-218.',
    date: new Date(2026, 4, 13),
    category: 'academic',
    allDay: true,
  },

  // May 14 — Thursday
  {
    id: 'may-immigrant-family-art',
    title: 'Title III Immigrant Family Art Workshop — Museum of Natural History, Grade 1',
    titleES: 'Taller de Arte Familiar Inmigrante Título III — Museo de Historia Natural, Grado 1',
    description: 'Title III Immigrant Family Art Workshop at the Museum of Natural History for Grade 1.',
    descriptionES: 'Taller de Arte Familiar para Inmigrantes Título III en el Museo de Historia Natural para 1.er grado.',
    date: new Date(2026, 4, 14),
    category: 'community',
    allDay: true,
  },
  {
    id: 'may-nyseslat-day2',
    title: 'K-4 NYSESLAT Day 2',
    titleES: 'NYSESLAT K-4 Día 2',
    description: 'NYSESLAT testing Day 2 for grades K-4.',
    descriptionES: 'Examen NYSESLAT Día 2 para los grados K-4.',
    date: new Date(2026, 4, 14),
    category: 'academic',
    allDay: true,
  },

  // May 15 — Friday
  {
    id: 'may-nyseslat-day3',
    title: 'K-4 NYSESLAT Day 3 — ELT Planning',
    titleES: 'NYSESLAT K-4 Día 3 — Planificación ELT',
    description: 'NYSESLAT testing Day 3 for grades K-4 and ELT Planning session.',
    descriptionES: 'Examen NYSESLAT Día 3 para los grados K-4 y sesión de planificación ELT.',
    date: new Date(2026, 4, 15),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'may-studio-installation',
    title: 'Studio in a School — Installation',
    titleES: 'Studio en la Escuela — Instalación',
    description: 'Studio in a School art installation event.',
    descriptionES: 'Evento de instalación artística de Studio en la Escuela.',
    date: new Date(2026, 4, 15),
    category: 'enrichment',
    allDay: true,
  },

  // May 16 — Saturday
  {
    id: 'may-sat-academy-family-celebration',
    title: 'Saturday Academy Family Celebration',
    titleES: 'Celebración Familiar de la Academia del Sábado',
    description: 'Saturday Academy Family Celebration at 11:00 AM.',
    descriptionES: 'Celebración Familiar de la Academia del Sábado a las 11:00 AM.',
    date: new Date(2026, 4, 16),
    category: 'community',
    allDay: false,
    startTime: '11:00 AM',
  },
  {
    id: 'may-community-forum',
    title: 'PS 85 Community Forum',
    titleES: 'Foro Comunitario de PS 85',
    description: 'PS 85 Community Forum at 12:30 PM.',
    descriptionES: 'Foro Comunitario de PS 85 a las 12:30 PM.',
    date: new Date(2026, 4, 16),
    category: 'community',
    allDay: false,
    startTime: '12:30 PM',
  },

  // May 18 — Monday
  {
    id: 'may-317-swim',
    title: '317 — Swim',
    titleES: '317 — Natación',
    description: 'Swimming session for Room 317.',
    descriptionES: 'Sesión de natación para el salón 317.',
    date: new Date(2026, 4, 18),
    category: 'enrichment',
    allDay: true,
  },

  // May 19 — Tuesday
  {
    id: 'may-liberty-science-trip',
    title: 'Grade 3 Liberty Science Center — 2-209 Swim',
    titleES: 'Excursión Grado 3 al Centro de Ciencias Liberty — Natación 2-209',
    description: 'Grade 3 field trip to Liberty Science Center with swimming in Room 2-209.',
    descriptionES: 'Excursión de 3.er grado al Centro de Ciencias Liberty con natación en el salón 2-209.',
    date: new Date(2026, 4, 19),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'may-mothers-day-event',
    title: "Mother's Day Event",
    titleES: 'Evento del Día de las Madres',
    description: "Special Mother's Day celebration event.",
    descriptionES: 'Celebración especial del Día de las Madres.',
    date: new Date(2026, 4, 19),
    category: 'community',
    allDay: true,
  },

  // May 20 — Wednesday
  {
    id: 'may-pta-meeting-breakfast',
    title: 'PTA Meeting Breakfast — 2-218 Swim',
    titleES: 'Desayuno de Reunión de la PTA — Natación 2-218',
    description: 'PTA Meeting Breakfast at 8:30 AM with swimming in Room 2-218.',
    descriptionES: 'Desayuno de Reunión de la PTA a las 8:30 AM con natación en el salón 2-218.',
    date: new Date(2026, 4, 20),
    category: 'community',
    allDay: false,
    startTime: '8:30 AM',
  },

  // May 21 — Thursday
  {
    id: 'may-family-game-night',
    title: 'Family Game Night',
    titleES: 'Noche de Juegos Familiares',
    description: 'Family Game Night from 4:30 PM to 6:00 PM.',
    descriptionES: 'Noche de Juegos Familiares de 4:30 PM a 6:00 PM.',
    date: new Date(2026, 4, 21),
    category: 'community',
    allDay: false,
    startTime: '4:30 PM',
    endTime: '6:00 PM',
  },

  // May 22 — Friday
  {
    id: 'may-studio-exhibit',
    title: 'Studio in School Exhibit',
    titleES: 'Exhibición de Studio en la Escuela',
    description: 'Studio in School art exhibit showcasing student work.',
    descriptionES: 'Exhibición artística de Studio en la Escuela que muestra el trabajo de los estudiantes.',
    date: new Date(2026, 4, 22),
    category: 'enrichment',
    allDay: true,
  },

  // May 25 — Monday
  {
    id: 'may-no-school-may25',
    title: 'No School',
    titleES: 'No Hay Escuela',
    description: 'School closed — no classes today.',
    descriptionES: 'Escuela cerrada — no hay clases hoy.',
    date: new Date(2026, 4, 25),
    category: 'holiday',
    allDay: true,
  },

  // May 26 — Tuesday
  {
    id: 'may-math-museum-trip',
    title: 'Grade 3 Field Trip to Math Museum — 2-209 Swim, Icee Day',
    titleES: 'Excursión Grado 3 al Museo de Matemáticas — Natación 2-209, Día del Helado',
    description: 'Grade 3 field trip to the Math Museum with swimming in Room 2-209 and Icee Day.',
    descriptionES: 'Excursión de 3.er grado al Museo de Matemáticas con natación en el salón 2-209 y Día del Helado.',
    date: new Date(2026, 4, 26),
    category: 'enrichment',
    allDay: true,
  },

  // May 27 — Wednesday
  {
    id: 'may-no-school-may27',
    title: 'No School',
    titleES: 'No Hay Escuela',
    description: 'School closed — no classes today.',
    descriptionES: 'Escuela cerrada — no hay clases hoy.',
    date: new Date(2026, 4, 27),
    category: 'holiday',
    allDay: true,
  },

  // May 28 — Thursday
  {
    id: 'may-midori-performance',
    title: 'Midori Performance & Celebration',
    titleES: 'Actuación y Celebración de Midori',
    description: 'Midori Performance and Celebration at 3:00 PM.',
    descriptionES: 'Actuación y Celebración de Midori a las 3:00 PM.',
    date: new Date(2026, 4, 28),
    category: 'enrichment',
    allDay: false,
    startTime: '3:00 PM',
  },
  {
    id: 'may-lucky-number-stuffed-animal',
    title: 'Lucky Number Stuffed Animal',
    titleES: 'Número de la Suerte — Animal de Peluche',
    description: 'Lucky Number Stuffed Animal spirit day.',
    descriptionES: 'Día de espíritu con el Número de la Suerte — Animal de Peluche.',
    date: new Date(2026, 4, 28),
    category: 'spirit',
    allDay: true,
  },

  // May 29 — Friday
  {
    id: 'may-midori-final',
    title: 'Midori Final Session & Reflection',
    titleES: 'Sesión Final y Reflexión de Midori',
    description: 'Final Midori session and reflection.',
    descriptionES: 'Sesión final y reflexión de Midori.',
    date: new Date(2026, 4, 29),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'may-scooter-raffle-may29',
    title: 'Scooter Raffle Day',
    titleES: 'Día de Rifa de Scooter',
    description: 'Scooter raffle day for students with excellent attendance.',
    descriptionES: 'Día de rifa de scooter para estudiantes con excelente asistencia.',
    date: new Date(2026, 4, 29),
    category: 'community',
    allDay: true,
  },
  {
    id: 'may-debate-awards',
    title: 'Debate Awards Ceremony',
    titleES: 'Ceremonia de Premios de Debate',
    description: 'Debate Awards Ceremony celebrating student debaters.',
    descriptionES: 'Ceremonia de Premios de Debate que celebra a los estudiantes debatientes.',
    date: new Date(2026, 4, 29),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'may-elt-planning-may29',
    title: 'ELT Planning',
    titleES: 'Planificación ELT',
    description: 'Extended Learning Time planning session.',
    descriptionES: 'Sesión de planificación del Tiempo de Aprendizaje Extendido.',
    date: new Date(2026, 4, 29),
    category: 'academic',
    allDay: true,
  },

  // ==================== SEPTEMBER 2026 ====================
  {
    id: 'prek-k-registration',
    title: 'Pre-K & Kindergarten Registration',
    titleES: 'Registro de Pre-K y Kínder',
    description: 'Families, you\'re invited! Come in and complete registration for Pre-K and Kindergarten. Please bring a birth certificate or passport, immunization records, photo ID, and two proofs of address. Child must be present.',
    descriptionES: '¡Familias, están invitadas! Vengan y completen el registro para Pre-K y Kínder. Traigan acta de nacimiento o pasaporte, registro de vacunas, identificación con foto y dos comprobantes de domicilio. El niño/a debe estar presente.',
    date: new Date(2026, 8, 1),
    endDate: new Date(2026, 8, 3),
    category: 'community',
    allDay: false,
    startTime: '9:00 AM',
  },
  {
    id: 'labor-day-2026',
    title: 'Labor Day — No School',
    titleES: 'Día del Trabajo — No Hay Escuela',
    description: 'School closed in observance of Labor Day.',
    descriptionES: 'Escuela cerrada en observancia del Día del Trabajo.',
    date: new Date(2026, 8, 7),
    category: 'holiday',
    allDay: true,
  },
  {
    id: 'back-to-school-jam',
    title: 'Back to School Jam',
    titleES: 'Regreso a Clases ¡JAM!',
    description: 'Join us as we kick off an exciting new and empowering school year! Backpack distribution, food, music, and games in the Cold Side Cafeteria. Pre-K–2nd grade 12:30–1:15 PM; 3rd–5th grade 1:30–2:15 PM.',
    descriptionES: '¡Acompáñanos para dar inicio a un nuevo y emocionante año escolar! Distribución de mochilas, alimentos, música y juegos en la Cafetería Cold Side. Preescolar a 2.º grado 12:30–1:15 PM; 3.º a 5.º grado 1:30–2:15 PM.',
    date: new Date(2026, 8, 9),
    category: 'community',
    allDay: false,
    startTime: '12:30 PM',
    endTime: '2:15 PM',
    location: 'Cold Side Cafeteria',
  },
  {
    id: 'first-day-of-school',
    title: 'First Day of School',
    titleES: 'Primer Día de Clases',
    description: 'Welcome back! The first day of the 2026–2027 school year. Every student receives a Back to School bracelet.',
    descriptionES: '¡Bienvenidos de nuevo! Primer día del año escolar 2026–2027. Cada estudiante recibe una pulsera de regreso a clases.',
    date: new Date(2026, 8, 10),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'sept-11-remembrance',
    title: 'September 11th Remembrance',
    titleES: 'Conmemoración del 11 de Septiembre',
    description: 'A day of remembrance honoring the lives lost on September 11, 2001.',
    descriptionES: 'Un día de conmemoración en honor a las vidas perdidas el 11 de septiembre de 2001.',
    date: new Date(2026, 8, 11),
    category: 'community',
    allDay: true,
  },
  {
    id: 'slt-meeting-sept',
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    description: 'School Leadership Team meeting.',
    descriptionES: 'Reunión del Equipo de Liderazgo Escolar.',
    date: new Date(2026, 8, 15),
    category: 'academic',
    allDay: false,
    startTime: '4:00 PM',
  },
  {
    id: 'hispanic-heritage-month',
    title: 'National Hispanic Heritage Month Begins',
    titleES: 'Comienza el Mes Nacional de la Herencia Hispana',
    description: 'National Hispanic Heritage Month runs from September 15 through October 15.',
    descriptionES: 'El Mes Nacional de la Herencia Hispana se celebra del 15 de septiembre al 15 de octubre.',
    date: new Date(2026, 8, 15),
    category: 'community',
    allDay: true,
  },
  {
    id: 'dads-take-child-to-school',
    title: 'Dads Take Your Child to School Day',
    titleES: 'Día de los Padres: Lleva a Tu Hijo/a al Colegio',
    description: 'Dads and father figures are invited to walk their child into school.',
    descriptionES: 'Se invita a los padres y figuras paternas a acompañar a su hijo/a a la escuela.',
    date: new Date(2026, 8, 17),
    category: 'community',
    allDay: true,
  },
  {
    id: 'treasure-box-day',
    title: 'Treasure Box Day',
    titleES: 'Día de la Caja del Tesoro',
    description: 'Treasure Box Day for our students.',
    descriptionES: 'Día de la Caja del Tesoro para nuestros estudiantes.',
    date: new Date(2026, 8, 18),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'yom-kippur-2026',
    title: 'Yom Kippur — No School',
    titleES: 'Yom Kipur — No Hay Escuela',
    description: 'School closed in observance of Yom Kippur.',
    descriptionES: 'Escuela cerrada en observancia de Yom Kipur.',
    date: new Date(2026, 8, 21),
    category: 'holiday',
    allDay: true,
  },
  {
    id: 'pajama-day-sept',
    title: 'Pajama Day',
    titleES: 'Día de Pijama',
    description: 'Wear your pajamas to school! Every student receives a small teddy bear.',
    descriptionES: '¡Ven en pijama a la escuela! Cada estudiante recibe un pequeño osito de peluche.',
    date: new Date(2026, 8, 22),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'crazy-hair-day',
    title: 'Crazy Hair Day',
    titleES: 'Día del Pelo Loco',
    description: 'Show off your craziest hairstyle!',
    descriptionES: '¡Muestra tu peinado más loco!',
    date: new Date(2026, 8, 23),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'heritage-colors-day',
    title: 'Heritage Colors Day',
    titleES: 'Día de los Colores del Patrimonio',
    description: 'Wear the colors of your heritage to celebrate our school community.',
    descriptionES: 'Usa los colores de tu herencia para celebrar nuestra comunidad escolar.',
    date: new Date(2026, 8, 24),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'marvel-day',
    title: 'Marvel Day',
    titleES: 'Día de Marvel',
    description: 'Celebrate Marvel Day! Every student receives a small super hero.',
    descriptionES: '¡Celebra el Día de Marvel! Cada estudiante recibe un pequeño superhéroe.',
    date: new Date(2026, 8, 25),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'back-to-school-night',
    title: 'Back to School Night & PTA Meeting',
    titleES: 'Noche de Regreso a Clases y Reunión de la PTA',
    description: 'Meet your child\'s teachers and learn about the year ahead, followed by the PTA meeting.',
    descriptionES: 'Conozca a los maestros de su hijo/a y aprenda sobre el año escolar, seguido de la reunión de la asociación de padres y maestros.',
    date: new Date(2026, 8, 30),
    category: 'community',
    allDay: false,
    startTime: '4:30 PM',
    endTime: '7:00 PM',
  },

  // ==================== OCTOBER 2026 ====================
  {
    id: 'sept-attendance-tag-day',
    title: 'September Attendance Tag Day',
    titleES: 'Día de la Etiqueta de Asistencia de Septiembre',
    description: 'Celebrating students with 100% attendance in September — they receive a bag tag.',
    descriptionES: 'Celebramos a los estudiantes con 100 % de asistencia en septiembre: reciben una etiqueta para su mochila.',
    date: new Date(2026, 9, 2),
    category: 'community',
    allDay: true,
  },
  {
    id: 'prek-elt-begins',
    title: 'Pre-K ELT Begins',
    titleES: 'Comienza el ELT de Pre-K',
    description: 'Extended Learning Time (ELT) begins for Pre-K.',
    descriptionES: 'Comienza el Tiempo de Aprendizaje Extendido (ELT) para Pre-K.',
    date: new Date(2026, 9, 5),
    category: 'academic',
    allDay: true,
  },
  {
    id: 'slt-meeting-oct',
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    description: 'School Leadership Team meeting at 4:00 PM.',
    descriptionES: 'Reunión del Equipo de Liderazgo Escolar a las 4:00 PM.',
    date: new Date(2026, 9, 6),
    category: 'academic',
    allDay: false,
    startTime: '4:00 PM',
  },
  {
    id: 'pumpkin-patch-day',
    title: 'PK/K Pumpkin Patch Day',
    titleES: 'Día de la Cosecha de Calabazas PK/K',
    description: 'Pre-K and Kindergarten Pumpkin Patch Day in the classrooms.',
    descriptionES: 'Día de la cosecha de calabazas en las aulas de Pre-K y Kínder.',
    date: new Date(2026, 9, 9),
    category: 'enrichment',
    allDay: true,
  },
  {
    id: 'indigenous-peoples-day-2026',
    title: 'Indigenous Peoples\' Day — No School',
    titleES: 'Día de los Pueblos Indígenas — No Hay Escuela',
    description: 'School closed in observance of Italian Heritage / Indigenous Peoples\' Day.',
    descriptionES: 'Escuela cerrada por el Día de la Herencia Italiana y de los Pueblos Indígenas.',
    date: new Date(2026, 9, 12),
    category: 'holiday',
    allDay: true,
  },
  {
    id: 'flag-day',
    title: 'Flag Day',
    titleES: 'Día de la Bandera',
    description: 'Flag Day observance.',
    descriptionES: 'Observancia del Día de la Bandera.',
    date: new Date(2026, 9, 13),
    category: 'community',
    allDay: true,
  },
  {
    id: 'hispanic-heritage-month-last-day',
    title: 'Last Day for Hispanic Heritage Month',
    titleES: 'Último Día del Mes de la Herencia Hispana',
    description: 'Last day for Hispanic Heritage Month.',
    descriptionES: 'Último día del Mes de la Herencia Hispana.',
    date: new Date(2026, 9, 13),
    category: 'community',
    allDay: true,
  },
  {
    id: 'jersey-day-oct',
    title: 'Jersey Day',
    titleES: 'Día de la Camiseta Deportiva',
    description: 'Spirit day — wear your favorite team jersey to school!',
    descriptionES: 'Día de espíritu — usa tu camiseta favorita de equipo.',
    date: new Date(2026, 9, 19),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'knicks-day',
    title: 'Knicks Day — Wear Blue and Orange',
    titleES: 'Día de los Knicks — Viste de Azul y Naranja',
    description: 'Spirit day — show your Knicks pride by wearing blue and orange!',
    descriptionES: 'Día de espíritu — ¡muestra tu orgullo por los Knicks vistiendo de azul y naranja!',
    date: new Date(2026, 9, 20),
    category: 'spirit',
    allDay: true,
  },
  {
    id: 'linc-parent-workshop',
    title: 'LINC Parent Workshop',
    titleES: 'Taller para Padres de LINC',
    description: 'LINC parent workshop.',
    descriptionES: 'Taller para padres de LINC.',
    date: new Date(2026, 9, 27),
    category: 'community',
    allDay: false,
  },
  {
    id: 'prek-sing-along-oct',
    title: 'Pre-K Sing-Along',
    titleES: 'Cantar Juntos Pre-K',
    description: 'Pre-K Sing-Along, 8:30–9:00 AM.',
    descriptionES: 'Cantar juntos de Pre-K, de 8:30 a 9:00 AM.',
    date: new Date(2026, 9, 30),
    category: 'enrichment',
    allDay: false,
    startTime: '8:30 AM',
    endTime: '9:00 AM',
  },
  {
    id: 'character-parade',
    title: 'Character Parade',
    titleES: 'Desfile de Personajes',
    description: 'Character Parade, starting at 9:00 AM.',
    descriptionES: 'El Desfile de Personajes comienza a las 9:00 AM.',
    date: new Date(2026, 9, 30),
    category: 'spirit',
    allDay: false,
    startTime: '9:00 AM',
  },
];

export default events;
